/**
 * Registers the worker that makes HIT installable on a phone's home screen.
 *
 * `serviceWorker` is missing from `navigator` outside a secure context, which
 * is why this can be called unconditionally: over plain HTTP, and in the
 * browser tests, it simply does nothing. A failed registration is never worth
 * breaking the page over — the site works, it just cannot be installed.
 *
 * @param navigatorRef Injectable for tests
 * @param path The worker, which has to be served from the root to claim the
 *             whole origin as its scope
 */
export const registerServiceWorker = async (
  navigatorRef: Navigator = navigator,
  path = '/sw.js',
): Promise<ServiceWorkerRegistration | null> => {
  if (!('serviceWorker' in navigatorRef)) {
    return null
  }

  try {
    return await navigatorRef.serviceWorker.register(path)
  } catch (error) {
    console.warn('Service worker registration failed', error)

    return null
  }
}
